<style lang="less" scoped>
.category {position: relative;width: 350px;text-align: left;font-family: AlibabaPuHuiTi-Regular;font-size: 16px;letter-spacing: 1px;}
ul {list-style: none;width: 350px;}
li {width: 160px;float: left;margin-bottom: 28px;margin-right: -14px;}
li:nth-child(7){width: 320px;float: left;margin-bottom: 28px;margin-right: -14px;}
li:hover {color: #13569e;cursor: pointer;}
.count{font-size: 12px;opacity: .6;}
</style>

<template>
  <div class="category">
    <ul>
      <li v-for="item in categoryList" :key="item.catid" @click="clickCategory(item.catid)">
        <span class="title">{{ item.dispc }}</span>
        <span class="count">({{ item.count }})</span>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽 2021.9.1
 * 该组件使用场景：将地学资料的所有新闻分为不同的类别，通过catid获取对应类别的数据，以标题加数量的形式进行展示。
 * 点击标题，将相应的对象传递给父组件
*/
export default {
  data()
  {
    return {
      categoryList: []  // 根据catid获取对应的分类数据
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.getCount()
        this.getCategory(+nval.query.catid)
      },
      immediate: true
    }
  },
  methods:
  {
    // 通过usersql，获取每个类别的数量
    getCount()
    {
      let paras = {cmd: 'getResource', _major: 11, _minor: 1}
      window.post.getZLKSum(paras).then()
      let paras1 = {cmd: 'query', _major: 11, _minor: 65, _exp: 'id>0'}
      this._count = window.post.getPost(paras1)
    },
    // 根据catid，获取当前在页面展示的分类浏览数据
    async getCategory(num)
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid=31'}
      let CountList = await this._count
      window.post.getPost(paras).then((ret) =>
      {
        this.categoryList = []
        //根据路由中的catid获取对应的分类类别
        let temp = []
        ret.forEach(item =>
        {
          if (parseInt(item.glid) === num)
            temp.push({catid: item.id, dispc: item.dispc})
        })
        //将CountList中所有的id存储在tempCatID中
        let tempCatID = []
        CountList.forEach(item => tempCatID.push(item.id))
        //遍历temp，获取对应类别的数量
        for (let i = 0; i < temp.length; i++)
        {
          if (tempCatID.indexOf(temp[i].catid) !== -1)
            this.categoryList.push({catid: temp[i].catid, dispc: temp[i].dispc, count: CountList[tempCatID.indexOf(temp[i].catid)].sl})
          else
            this.categoryList.push({catid: temp[i].catid, dispc: temp[i].dispc, count: 0})
        }
      })
    },
    // 点击分类选项，将 选中的对象的catid 传递给父组件
    clickCategory(catid)
    {
      this.$emit('clickCategory', catid)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/CategoryZLK.vue